export const galleryItems = [
  {
    id: "1",
    title: "Morning Light in the Courtyard",
    category: "The Space",
    image:
      "https://readdy.ai/api/search-image?query=Beautiful%20cafe%20courtyard%20interior%20with%20morning%20sunlight%20streaming%20through%20glass%20ceiling%2C%20green%20plants%2C%20wooden%20tables%2C%20warm%20natural%20lighting%2C%20editorial%20architecture%20photography%20style%2C%20serene%20peaceful%20atmosphere&width=800&height=600&seq=gallery-space-1&orientation=landscape",
    description: "The courtyard at 7 AM, before the day begins.",
  },
  {
    id: "2",
    title: "The Making of Ala Kiev",
    category: "Food",
    image:
      "https://readdy.ai/api/search-image?query=Chefs%20hands%20carefully%20preparing%20chicken%20ala%20kiev%20in%20professional%20kitchen%2C%20herb%20butter%20filling%2C%20flour%20dusting%2C%20warm%20kitchen%20lighting%2C%20editorial%20documentary%20photography%20style%2C%20intimate%20behind-the-scenes&width=800&height=600&seq=gallery-food-1&orientation=landscape",
    description: "Chef Arjun prepares the signature dish.",
  },
  {
    id: "3",
    title: "Sunday Brunch Gathering",
    category: "People",
    image:
      "https://readdy.ai/api/search-image?query=Group%20of%20friends%20enjoying%20brunch%20at%20outdoor%20cafe%20table%2C%20laughing%20and%20conversing%2C%20warm%20natural%20lighting%2C%20editorial%20lifestyle%20photography%20style%2C%20genuine%20moments%20of%20joy%2C%20food%20and%20coffee%20on%20table&width=800&height=600&seq=gallery-people-1&orientation=landscape",
    description: "Conversations flow best over good food.",
  },
  {
    id: "4",
    title: "Poetry Evening",
    category: "Events",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20cafe%20evening%20event%20with%20soft%20candlelight%2C%20people%20seated%20in%20intimate%20arrangement%2C%20warm%20ambient%20lighting%2C%20editorial%20event%20photography%20style%2C%20acoustic%20guitar%20in%20corner%2C%20literary%20salon%20atmosphere&width=800&height=600&seq=gallery-event-1&orientation=landscape",
    description: "Our monthly poetry evening under the stars.",
  },
  {
    id: "5",
    title: "The Perfect Espresso Moment",
    category: "Moments",
    image:
      "https://readdy.ai/api/search-image?query=Close-up%20of%20perfect%20espresso%20being%20poured%20into%20vintage%20ceramic%20cup%2C%20rich%20crema%20forming%2C%20warm%20cafe%20background%20blurred%2C%20editorial%20coffee%20photography%20style%2C%20intimate%20macro%20shot%2C%20golden%20warm%20tones&width=800&height=600&seq=gallery-moment-1&orientation=landscape",
    description: "Every pour is a small ceremony.",
  },
  {
    id: "6",
    title: "Tiramisu Assembly",
    category: "Food",
    image:
      "https://readdy.ai/api/search-image?query=Pastry%20chef%20carefully%20assembling%20tiramisu%20layers%20in%20glass%20dish%2C%20mascarpone%20cream%2C%20ladyfingers%2C%20cocoa%20powder%20dusting%2C%20warm%20kitchen%20lighting%2C%20editorial%20food%20photography%20style%2C%20artisanal%20dessert%20preparation&width=800&height=600&seq=gallery-food-2&orientation=landscape",
    description: "Layer by layer, patience becomes dessert.",
  },
];